import React from 'react';
import { Button, Form } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const semesters = [
    {
        key: 'prvi',
        value: 'prvi',
        text: 'prvi'
    },
    {
        key: 'drugi',
        value: 'drugi',
        text: 'drugi'
    },
    {
        key: 'treći',
        value: 'treći',
        text: 'treći'
    },
    {
        key: 'četvrti',
        value: 'četvrti',
        text: 'četvrti'
    },
    {
        key: 'peti',
        value: 'peti',
        text: 'peti'
    },
    {
        key: 'šesti',
        value: 'šesti',
        text: 'šesti'
    },
    {
        key: 'sedmi',
        value: 'sedmi',
        text: 'sedmi'
    },
    {
        key: 'osmi',
        value: 'osmi',
        text: 'osmi'
    },
    {
        key: 'deveti',
        value: 'deveti',
        text: 'deveti'
    },
    {
        key: 'deseti',
        value: 'deseti',
        text: 'deseti'
    }
];

export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',
            studyProgramId: '',
            studyProgramSemesterName: ''
        };
        this.onFilterData = this.onFilterData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    onFilterData() {
        if (!this.state.firstName && !this.state.lastName && !this.state.index && !this.state.studyProgramId && !this.state.studyProgramSemesterName) {
            toast('Morate unijeti po čemu želite filtrirati podatke!');
        } else if (this.props.sp && this.props.noIndex) {
            this.props.onFilterData(
                this.state.firstName,
                this.state.lastName,
                this.state.studyProgramId
            );
        } else if (this.props.semester) {
            this.props.onFilterData(
                this.state.studyProgramId,
                this.state.studyProgramSemesterName
            );
        } else {
            this.props.onFilterData(
                this.state.firstName,
                this.state.lastName,
                this.state.index,
                this.state.studyProgramId
            );
        }
    }


    render() {
        return (
            <div>
                {/* {!this.props.noIndex && <div><br /><br /></div>} */}
                <Form>
                    <Form.Group widths="equal">
                        {(this.props.sp || this.props.semester) && <Form.Field>
                            <label>Smjer (studijski program)</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite smjer (studijski program)"
                                value={this.state.studyProgramId}
                                onChange={this.handleInputChange}
                                name="studyProgramId"
                                options={this.props.studyPrograms}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>}
                        {this.props.semester && <Form.Field>
                            <label>Semestar</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite smemestar"
                                value={this.state.studyProgramSemesterName}
                                onChange={this.handleInputChange}
                                name="studyProgramSemesterName"
                                options={semesters}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>}
                        {(!this.props.semester && !this.props.sp) &&  <Form.Field>
                            <label>Ime</label>
                            <input
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name="firstName"
                                placeholder="Unesite ime"
                            />
                        </Form.Field>}
                        {(!this.props.semester && !this.props.sp) &&  <Form.Field>
                            <label>Prezime</label>
                            <input
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name="lastName"
                                placeholder="Unesite prezime"
                            />
                        </Form.Field>}
                        {(!this.props.noIndex && !this.props.semester && !this.props.sp) && <Form.Field>
                            <label>Broj indexa</label>
                            <input
                                value={this.state.index}
                                onChange={(e) => this.setState({ index: e.target.value })}
                                name="index"
                                placeholder="Unesite index"
                            />
                        </Form.Field>}
                        {this.props.sp && <Form.Field></Form.Field>}

                    </Form.Group>
                    <Button basic="true" color="blue" floated="right" onClick={this.props.filtersOff}>Odustani
                    </Button>
                    <Button color="blue" floated="right" onClick={this.onFilterData}>Filtriraj
                    </Button>
                </Form>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/Filters.js